import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import {
  RibbonMarquee, Manifesto, WhoWeServe, ConnectedServices,
  HowItWorks, AvailabilityBand, Footer,
} from "@/components/site/Sections";
import { IntakeForm, ContactForm } from "@/components/site/Forms";

export default function Landing() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="landing-page">
      <Nav />
      <Hero onApply={() => scrollTo("apply")} onLearn={() => scrollTo("mission")} />
      <RibbonMarquee />
      <Manifesto />
      <WhoWeServe />
      <ConnectedServices />
      <HowItWorks />
      <AvailabilityBand onApply={() => scrollTo("apply")} />
      <IntakeForm />
      <ContactForm />
      <Footer />
    </div>
  );
}
